import {useState} from 'react';
import uniq from 'lodash/uniq';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import SelectProviderInput from '../providers/SelectProviderInput';

import {useUpdateLeadMutation} from '../../redux/services/leadApi';

const handleSave = ({put, lead, onClose}) => subscriber_id => async e => {
  const subscriber_ids = uniq([
    ...lead.subscriber_ids,
    subscriber_id,
  ]);
  const request = await put({
    id: lead.id,
    body: {
      subscriber_ids,
    },
  });
  if (request.error) {
    console.error('Error updating lead subscribers:', request.error);
    return;
  }
  onClose();
};

const LeadSubscriberDialog = ({dialogIsOpen, onClose, lead}) => {
  const [subscriberId, setSubscriberId] = useState(null);
  const [put] = useUpdateLeadMutation();
  const onSave = handleSave({put, lead, onClose});
  return (
      <Dialog
        open={dialogIsOpen}
        maxWidth='xs'
        minWidth='xs'        
        onClose={onClose}
      >
        <DialogContent style={{padding: 0, minWidth: 300}}>
          <Box padding={4} sx={{display: 'flex', flexGrow: 1, flexDirection: 'row', gap: 2}}>
            <SelectProviderInput 
              label='Add Subscriber'
              fullWidth={true}
              value={subscriberId}
              onChange={e => setSubscriberId(e.target.value)}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='primary'>Cancel</Button>
          <Button
            onClick={onSave(subscriberId)}
            color='primary'
            disabled={!subscriberId}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default LeadSubscriberDialog;